import { axiosDS } from '@pp/axios'
import { ResponseCatalog, RequestParams } from 'Models'
import { urls } from 'Src/constants/Urls'
import { LandingCreateModel, LandingModel } from 'Pages/admin'
import { serialize } from 'object-to-formdata'
import { Id } from 'Src/types/aliases'

export const landingApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<LandingModel>>(urls.landing.index, {
			params,
		})
		return res.data
	},
	getOne: async (id: Id) => {
		const res = await axiosDS().get<LandingModel>(`${urls.landing.index}/${id}`)
		return res.data
	},
	createOne: async (data: LandingCreateModel) => {
		const res = await axiosDS().post<LandingModel>(
			urls.landing.index,
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	updateOne: async (id: Id, data: LandingModel) => {
		const res = await axiosDS().patch<LandingModel>(
			`${urls.landing.index}/${id}`,
			data?.sticker || data?.banner ? serialize({ data }, { allowEmptyArrays: true }) : { data }
		)
		return res.data
	},
	deleteOne: async (id: Id) => {
		await axiosDS().delete(`${urls.landing.index}/${id}`)
	},
	deleteSticker: async (id: Id) => {
		await axiosDS().delete(`${urls.landing.index}/${id}/delete_sticker`)
	},
	deleteBanner: async (id: Id) => {
		await axiosDS().delete(`${urls.landing.index}/${id}/delete_banner`)
	},
}
